import { useCallback } from "react";
import GameMpProvider from "@/core/data-provider/data-mp/game/game-mp-provider";

export default function useHidePc() {
  const hidePc = useCallback(() => {
    GameMpProvider.closeCurrentInterface(true);
  }, []);

  return { hidePc };
}
